<template>
    <div id="app">
        <div>
 <div class="headerbar"
             v-if="!$route.meta.isHeaderHide">
            <navHeader></navHeader>
        </div>
        </div>
       
        <div class="main_sidebar"
             v-if="!$route.meta.isNavHide">
            <navMenu></navMenu>
        </div>
        <div class="content_wrapper">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
    name: 'App',
    mounted: function () {
        let _beforeUnload_time = 0, _gap_time = 0;
        window.addEventListener('beforeunload', e => {
            _beforeUnload_time = new Date().getTime();
        });
        window.addEventListener('unload', res => {
            let name = location.pathname.replace('/', '')
            console.log(this.$route.query)
            _gap_time = new Date().getTime() - _beforeUnload_time;
            if (_gap_time <= 5) {  // 浏览器关闭
                Cookies.set('admin_token', '');
                Cookies.set('account', '');
            }
        });
    }
}
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
}
.content_wrapper {
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue